export { watchLogin } from './login';
export { watchRegistrar } from './registrar';
export { watchLogout } from './logout';



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/redux/sagas.js